import React, { Component } from 'react';
import { isEmpty } from "lodash";
import InputText, { TextArea } from '../../../commonModules/interface/form-input-inline';
import PopUp from '../../../commonModules/interface/PopUp';
import Photos from '../../../commonModules/interface/input-files';
import { toast } from 'react-toastify';


class ProjectForm extends Component {
    state = {
        data:{
            payg_project_name: "",
            payg_project_desc: "",
            payg_project_p1: "",
            payg_total_price: this.props.client.totalToPay,
            payg_project_city: "",
            payg_project_country: "",
            payg_impact: "",
            payg_project_length: "",
            payg_photo_info: [],

        },
        errors: {
            payg_project_name: "",
            payg_project_desc: "",
            payg_project_p1: "",
            payg_total_price: "",
            payg_project_city: "",
            payg_project_country: "",
            payg_impact: "",
            payg_project_length: "",
        }
    }
    handleChange = (e) => {
        const {name, value} = e.target;

        this.setState({
            data:{
                ...this.state.data,
                [name]: value
            }
        })
    }
    validate = () => {
        let required = Object.keys(this.state.data)
        let noErrors = true
        let errors = {}

        required.forEach( field => {
            if(this.state.data[field] === "" ){
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
            } else {
                errors[field] = ""
            }
        })

        this.setState({
            errors
        })
        return noErrors
    }
    handleSubmit = async () => {
        if( this.validate() ){
            let data = Object.assign({}, this.state.data)
            data.payg_creation_date = new Date()
            data.payg_total_price = parseFloat(this.state.data.payg_total_price)
            data.payg_project_length = parseInt(this.state.data.payg_project_length)
            data.payg_impact = parseInt(this.state.data.payg_impact)
            data.payg_creator_ref = this.props.refID
            data.payg_ID = this.props.client.idBox
            data.payg_photo_info = !isEmpty(this.state.data.payg_photo_info) ? this.state.data.payg_photo_info[0] : {}
    
            let req = await fetch("/crowdlending/new/project",{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify(data),
                credentials: 'same-origin',
            })
            let res = await req.json()
    
            console.log('===========SUBMIT PROJECT=====================');
            console.log({res});
            console.log('====================================');
            if(res.error){
                console.log('====================================');
                console.log(res.error.error);
                console.log('====================================');
                toast.error(  res.error.error)
            } else {
                toast.success( "Projet envoyé")
                this.submitUpdate(res.data.payg_project_id)
                this.props.handleClose()
            }

        } else {
            toast.error(  "Le formulaire contient des erreurs")
        }
    }
    submitUpdate = async (projectID) => {
        // update user status
        let data = {
            paygoID: this.props.client.idBox,
            status: "FUNDING",
            projectID: projectID,
        }
        let req = await fetch("/crowdlending/update/user/status",{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            body: JSON.stringify(data),
            credentials: 'same-origin',
        })
        let res = await req.json()

        if(res.error){
            console.log('===========SUBMIT UPDATE ERROR============');
            console.log({res});
            console.log('====================================');
            toast.error(  res.error.error)
        } else {
            this.props.updateList(data)
        }
    }
    setPhoto = (photo) => {
        this.setState({
            data:{
                ...this.state.data,
                payg_photo_info: photo
            }
        })
    }
    render(){
        console.log('==========PROJECT FORM ====================');
        console.log(this.state.data);
        console.log('====================================');
        return (
            <PopUp
                block={true} 
                close={this.props.handleClose}
                title="Financement du Projet"
                submitAction={this.handleSubmit}
                submitTitle="Valider"
                // submit={(
                //     <div>
                //         <button className="btn btn-success btn-lg" onClick={this.handleSubmit}>Valider</button>
                //         <button className="btn btn-lg" onClick={this.props.handleClose}>Annuler</button>
                //     </div>
                // )}
            >
            <div className="form-horizontal">
                <InputText
                    change={this.handleChange} 
                    errorClass={!!this.state.errors.payg_project_name}
                    error={this.state.errors.payg_project_name}
                    value={this.state.data.payg_project_name} 
                    name="payg_project_name" 
                    title="Nom du projet"
                    placeholder="Financement d'un kit pour ..."
                />
                <TextArea 
                    change={this.handleChange} 
                    errorClass={!!this.state.errors.payg_project_desc}
                    error={this.state.errors.payg_project_desc}
                    value={this.state.data.payg_project_desc} 
                    name="payg_project_desc" 
                    title="Description Courte"/>
                <TextArea 
                    change={this.handleChange} 
                    errorClass={!!this.state.errors.payg_project_p1}
                    error={this.state.errors.payg_project_p1}
                    value={this.state.data.payg_project_p1} 
                    name="payg_project_p1" 
                    title="Présentation du Projet"/>
                
                <InputText 
                    change={this.handleChange} 
                    errorClass={!!this.state.errors.payg_project_city}
                    error={this.state.errors.payg_project_city}
                    value={this.state.data.payg_project_city} 
                    name="payg_project_city" 
                    title="Ville"/>
                <InputText 
                    change={this.handleChange} 
                    errorClass={!!this.state.errors.payg_project_country}
                    error={this.state.errors.payg_project_country}
                    value={this.state.data.payg_project_country} 
                    name="payg_project_country" 
                    title="Pays"/>
                <InputText 
                    change={this.handleChange} 
                    errorClass={!!this.state.errors.payg_impact}
                    error={this.state.errors.payg_impact}
                    value={this.state.data.payg_impact} 
                    name="payg_impact" 
                    title="Nombre de Personnes Impactées"/>
                <InputText 
                    change={this.handleChange} 
                    errorClass={!!this.state.errors.payg_project_length}
                    error={this.state.errors.payg_project_length}
                    value={this.state.data.payg_project_length} 
                    name="payg_project_length" 
                    title="Durée de l'abonnement"
                    palceholder="Durée de l'abonnement (en mois)"
                />
                <InputText 
                    change={this.handleChange} 
                    errorClass={!!this.state.errors.payg_total_price}
                    error={this.state.errors.payg_total_price}
                    value={this.state.data.payg_total_price} 
                    name="payg_total_price" 
                    title="Coût Total"/>
                <div className="form-group ">
                    <label htmlFor="payg_photo_info" className={"col-sm-3 control-label"}>Photo</label>
                    <div className="col-sm-9">
                        <Photos photos={this.state.data.payg_photo_info} max={1} photoList={this.setPhoto} />
                    </div>
                </div> 
            </div>
            </PopUp>
        )
    }
}

export default ProjectForm